import React, { useEffect } from "react";
import {
  Accordion,
  Button,
  Card,
  Form,
  FormControl,
  Table
} from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";

var pluralize = require("pluralize");

const supportedDataTypes = [
  "Select datatype",
  "bigIncrements",
  "bigInteger",
  "binary",
  "boolean",
  "char",
  "dateTimeTz",
  "dateTime",
  "date",
  "decimal",
  "double",
  "enum",
  "float",
  "foreignId",
  "foreignIdFor",
  "foreignUuid",
  "geometryCollection",
  "geometry",
  "id",
  "increments",
  "integer",
  "ipAddress",
  "json",
  "jsonb",
  "lineString",
  "longText",
  "macAddress",
  "mediumIncrements",
  "mediumInteger",
  "mediumText",
  "morphs",
  "multiLineString",
  "multiPoint",
  "multiPolygon",
  "nullableMorphs",
  "nullableTimestamps",
  "nullableUuidMorphs",
  "point",
  "polygon",
  "rememberToken",
  "set",
  "smallIncrements",
  "smallInteger",
  "softDeletesTz",
  "softDeletes",
  "string",
  "string:5",
  "string:10",
  "string:50",
  "string:100",
  "string:500",
  "text",
  "timeTz",
  "time",
  "timestampTz",
  "timestamp",
  "timestampsTz",
  "timestamps",
  "tinyIncrements",
  "tinyInteger",
  "tinyText",
  "unsignedBigInteger",
  "unsignedDecimal",
  "unsignedInteger",
  "unsignedMediumInteger",
  "unsignedSmallInteger",
  "unsignedTinyInteger",
  "uuidMorphs",
  "uuid",
  "year"
];

const initialList = [
  // {
  //   id: "a",
  //   colName: "member1",
  //   dataType: "id",
  //   options: "nullable",
  //   isUnique: false,
  //   isAuto: false,
  //   isNull: false
  // },
  // {
  //   id: "b",
  //   colName: "member2",
  //   dataType: "integer",
  //   options: "default",
  //   isUnique: false,
  //   isAuto: false,
  //   isNull: false
  // }
];

export default function ModelMembers(props) {
  const [columnList, setColumnList] = React.useState(initialList);
  const [colName, setColName] = React.useState("");
  const [manualCode, setManualCode] = React.useState(false);
  const [manualDataModel, setmanualDataModel] = React.useState("");
  const [manualMigration, setmanualMigration] = React.useState("");
  const [manualSeeder, setmanualSeeder] = React.useState("");
  const [manualFactory, setmanualFactory] = React.useState("");
  const [manualController, setmanualController] = React.useState("");

  function updateParent() {
    //console.log("updates sent to parent");
    props.updateMembers(props.id, "members", columnList);
  }

  function generateModel() {
    let concatStr = "";
    let attrStr = "";
    let len = columnList.length;
    for (let i = 0; i < len; i++) {
      let quotedName = `'` + columnList[i].colName.toLocaleLowerCase() + `'`;
      concatStr += quotedName;
      attrStr += `  ` + quotedName + ` => ''`;
      if (i < len - 1) {
        concatStr += `,`;
        attrStr += `,
`;
      }
    }

    return (
      `
<?php

namespace App\\Models;

use Illuminate\\Database\\Eloquent\\Factories\\HasFactory;
use Illuminate\\Database\\Eloquent\\Model;

class ` +
      props.name +
      ` extends Model
{
  use HasFactory;
  //
}

/*
protected $connection = 'sqlite';
protected $table = 'custom_table_name';
protected $primaryKey = 'custom_primary_key_id';
public $incrementing = false;
protected $keyType = 'string';
public $timestamps = false;
protected $guarded = [` +
      concatStr +
      `];
protected $fillable = [` +
      concatStr +
      `];
protected $hidden = [` +
      concatStr +
      `];
protected $with = [` +
      concatStr +
      `];

//set default values to attributes
protected $attributes = [
  ` +
      attrStr +
      `
];
*/
`
    );
  }

  function generateSeeder() {
    let plural = pluralize(props.name);

    return (
      `
<?php

namespace Database\\Seeders;

use Illuminate\\Database\\Seeder;

class ` +
      props.name +
      `Seeder extends Seeder
{
    /**
     * Run the database seeds.
     *
     * @return void
     */
    public function run()
    {
        //
    }
}

    `
    );
  }

  function generateFactory() {
    let concatStr = "";
    for (let i = 0; i < columnList.length; i++) {
      concatStr +=
        `
        '` +
        columnList[i].colName.toLocaleLowerCase() +
        `' => $this->faker->sentence,`;
    }

    return (
      `
<?php

namespace Database\\Factories;

use Illuminate\\Database\\Eloquent\\Factories\\Factory;

class ` +
      props.name +
      `Factory extends Factory
{
    /**
     * Define the model's default state.
     *
     * @return array
     */
    public function definition()
    {
        return [
            ` +
      concatStr +
      `
        ];
    }
}
    `
    );
  }

  function generateMigration() {
    let plural = pluralize(props.name);

    let columns = "";
    for (let i = 0; i < columnList.length; i++) {
      console.log(columnList[i].isUnique);
      let uniqueStr = columnList[i].isUnique === true ? `->unique()` : ``;
      let autoStr = columnList[i].isAuto === true ? `->autoIncrement()` : ``;
      let nullStr = columnList[i].isNull === true ? `->nullable()` : ``;

      columns +=
        `            $table->` +
        columnList[i].dataType.toLocaleLowerCase() +
        `(` +
        columnList[i].colName.toLocaleLowerCase() +
        `)` +
        uniqueStr +
        autoStr +
        nullStr +
        `;
`;
    }

    return (
      `
<?php

use Illuminate\\Database\\Migrations\\Migration;
use Illuminate\\Database\\Schema\\Blueprint;
use Illuminate\\Support\\Facades\\Schema;

class Create` +
      plural +
      `Table extends Migration
{
    /**
     * Run the migrations.
     *
     * @return void
     */
    public function up()
    {
        Schema::create('` +
      plural.toLocaleLowerCase() +
      `', function (Blueprint $table) {
            $table->id();
` +
      columns +
      `
            $table->timestamps();
        });
    }

    /**
     * Reverse the migrations.
     *
     * @return void
     */
    public function down()
    {
        Schema::dropIfExists('` +
      plural.toLocaleLowerCase() +
      `');
    }
}    
    `
    );
  }

  function generateController() {
    return (
      `
<?php

namespace App\\Http\\Controllers;

use Illuminate\\Http\\Request;

class ` +
      props.name +
      `Controller extends Controller
{
    /**
     * Display a listing of the resource.
     *
     * @return \\Illuminate\\Http\\Response
     */
    public function index()
    {
        //
    }

    /**
     * Show the form for creating a new resource.
     *
     * @return \\Illuminate\\Http\\Response
     */
    public function create()
    {
        //
    }

    /**
     * Store a newly created resource in storage.
     *
     * @param  \\Illuminate\\Http\Request  $request
     * @return \\Illuminate\\Http\\Response
     */
    public function store(Request $request)
    {
        //
    }

    /**
     * Display the specified resource.
     *
     * @param  int  $id
     * @return \\Illuminate\\Http\\Response
     */
    public function show($id)
    {
        //
    }

    /**
     * Show the form for editing the specified resource.
     *
     * @param  int  $id
     * @return \\Illuminate\\Http\\Response
     */
    public function edit($id)
    {
        //
    }

    /**
     * Update the specified resource in storage.
     *
     * @param  \\Illuminate\\Http\\Request  $request
     * @param  int  $id
     * @return \\Illuminate\\Http\\Response
     */
    public function update(Request $request, $id)
    {
        //
    }

    /**
     * Remove the specified resource from storage.
     *
     * @param  int  $id
     * @return \\Illuminate\\Http\\Response
     */
    public function destroy($id)
    {
        //
    }
}
`
    );
  }

  function generateManualCode() {
    setmanualDataModel(unescape(generateModel()));
    setmanualMigration(unescape(generateMigration()));
    setmanualSeeder(unescape(generateSeeder()));
    setmanualFactory(unescape(generateFactory()));
    setmanualController(unescape(generateController()));
  }

  useEffect(() => {
    // Update the document title using the browser API
    //console.log("Detected changes in columnList");
    updateParent();
    generateManualCode();
  }, [columnList]);

  function handleChange(event) {
    setColName(event.target.value);
  }

  function addColumn() {
    console.log(colName);
    const newList = columnList.concat({
      id: uuidv4(),
      colName: colName,
      dataType: "",
      options: "",
      isUnique: false,
      isAuto: false,
      isNull: false
    });

    setColumnList(newList);
    setColName("");
  }

  function removeColumn(id) {
    const newList = columnList.filter((item) => item.id !== id);

    setColumnList(newList);
  }

  function updateDataType(id, key, value) {
    const newList = columnList.map((item) => {
      if (item.id === id) {
        const updatedItem = {
          ...item,
          [key]: value
        };
        return updatedItem;
      }

      return item;
    });
    setColumnList(newList);
  }

  const renderAuthButton = () => {
    if (manualCode) {
      return (
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>Data model</Accordion.Header>
            <Accordion.Body>
              <FormControl
                as="textarea"
                aria-label="With textarea"
                rows={15}
                value={manualDataModel}
              />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>Migration</Accordion.Header>
            <Accordion.Body>
              <FormControl
                as="textarea"
                aria-label="With textarea"
                rows={15}
                value={manualMigration}
              />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <Accordion.Header>Controller</Accordion.Header>
            <Accordion.Body>
              <FormControl
                as="textarea"
                aria-label="With textarea"
                rows={15}
                value={manualController}
              />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3">
            <Accordion.Header>Seeder</Accordion.Header>
            <Accordion.Body>
              <FormControl
                as="textarea"
                aria-label="With textarea"
                rows={15}
                value={manualSeeder}
              />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="4">
            <Accordion.Header>Factory</Accordion.Header>
            <Accordion.Body>
              <FormControl
                as="textarea"
                aria-label="With textarea"
                rows={15}
                value={manualFactory}
              />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      );
    } else {
      return "";
    }
  };

  return (
    <div>
      <Card>
        <Card.Header>
          <b>{props.name}</b>
          <AddItem
            id={props.id}
            name={colName}
            onChange={handleChange}
            onAdd={addColumn}
          />
        </Card.Header>
        {/* {columnList.map((item, index) => (
          <p>
            {item.id} {item.colName} {item.dataType} {item.options}
          </p>
        ))} */}
        <Card.Body>
          {columnList.length > 0 && (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Column name</th>
                  <th>Data type</th>
                  <th>Options</th>
                  <th>Unique</th>
                  <th>Auto increment</th>
                  <th>Nullable</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {columnList.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.colName}</td>
                    <td>
                      <Form.Select
                        onChange={(e) =>
                          updateDataType(item.id, "dataType", e.target.value)
                        }
                        value={item.dataType}
                      >
                        {supportedDataTypes.map((option, ix) => (
                          <option key={ix} value={option}>
                            {option}
                          </option>
                        ))}
                      </Form.Select>
                    </td>
                    <td>
                      <FormControl
                        as="textarea"
                        placeholder="Add nullable default enum etc.."
                        value={item.options}
                        onChange={(e) =>
                          updateDataType(item.id, "options", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <Form.Check
                        type="checkbox"
                        checked={item.isUnique} // React checkbox onChange get value
                        onChange={(e) => {
                          updateDataType(item.id, "isUnique", e.target.checked);
                        }} // React checkbox onChange setState
                      />
                    </td>
                    <td>
                      <Form.Check
                        type="checkbox"
                        checked={item.isAuto} // React checkbox onChange get value
                        onChange={(e) => {
                          updateDataType(item.id, "isAuto", e.target.checked);
                        }} // React checkbox onChange setState
                      />
                    </td>
                    <td>
                      <Form.Check
                        type="checkbox"
                        checked={item.isNull} // React checkbox onChange get value
                        onChange={(e) => {
                          updateDataType(item.id, "isNull", e.target.checked);
                        }} // React checkbox onChange setState
                      />
                    </td>
                    <td>
                      <Button
                        variant="danger"
                        onClick={() => removeColumn(item.id)}
                      >
                        {"Remove "}
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
          <Form.Check
            type="checkbox"
            checked={manualCode} // React checkbox onChange get value
            label={`Generate manual code as well `}
            onChange={(e) => {
              setManualCode(e.target.checked);
              //setAddModel(e.target.checked);
            }} // React checkbox onChange setState
          />
          {renderAuthButton()}
        </Card.Body>
      </Card>
    </div>
  );
}

const AddItem = ({ name, onChange, onAdd }) => (
  <div class="d-flex justify-content-end ">
    <Form.Control
      type="text"
      autoFocus
      placeholder="Enter a model / table name"
      value={name}
      onChange={onChange}
    />
    <span>&nbsp;</span>
    <Button onClick={onAdd}>Add column</Button>
  </div>
);
